export const DEFAULT_PHONE_EXTENSION_FORMAT = '(######)'
